<p-dialog
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '68rem', maxWidth: '96vw' }"
  (visibleChange)="visibleChange.emit($event)"
>
  <ng-template pTemplate="header">
    <span class="text-lg font-semibold text-gray-800">
      {{
        (operationType === 'UNPACK'
          ? 'package_operation.form.unpack_title'
          : 'package_operation.form.pack_title') | translate
      }}
    </span>
  </ng-template>

  @if (packageSku) {
    <form [formGroup]="operationForm" class="operation-form">
      <div class="operation-package-info">
        <strong>{{ packageSku.skuName }}</strong>
        <span>{{ packageSku.skuCode }}</span>
      </div>

      <div class="operation-form-fields">
        <div class="operation-field">
          <label for="package-operation-warehouse">
            {{ 'package_operation.form.warehouse' | translate }}
          </label>
          <p-select
            inputId="package-operation-warehouse"
            formControlName="warehouseId"
            [options]="warehouseOptions"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            [placeholder]="'package_operation.form.select_warehouse' | translate"
            class="w-full"
            (onChange)="warehouseChange.emit()"
          ></p-select>
        </div>

        <div class="operation-field">
          <label for="package-operation-qty">
            {{ 'package_operation.form.package_qty' | translate }}
          </label>
          <p-inputNumber
            inputId="package-operation-qty"
            formControlName="packageQty"
            [min]="1"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            [useGrouping]="false"
            class="w-full"
            (onInput)="quantityChange.emit()"
          ></p-inputNumber>
        </div>

        @if (operationType === 'UNPACK') {
          <div class="operation-field operation-field-wide">
            <label for="package-operation-source-pack">
              {{ 'package_operation.form.source_pack' | translate }}
            </label>
            <p-select
              inputId="package-operation-source-pack"
              formControlName="sourcePackOperationId"
              [options]="sourcePackOptions()"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              [loading]="sourcePacksLoading"
              [disabled]="!operationForm.controls.warehouseId.value"
              [placeholder]="'package_operation.form.select_source_pack' | translate"
              class="w-full"
              (onChange)="sourcePackChange.emit()"
            ></p-select>
          </div>
        }

        <div class="operation-field operation-field-wide">
          <label for="package-operation-reason">
            {{ 'package_operation.form.reason' | translate }}
          </label>
          <textarea
            pTextarea
            id="package-operation-reason"
            formControlName="reason"
            rows="2"
            class="w-full"
            [placeholder]="'package_operation.form.reason_placeholder' | translate"
          ></textarea>
        </div>
      </div>

      @if (validationMessage) {
        <div class="operation-validation-message" role="alert">
          {{ validationMessage | translate }}
        </div>
      }

      <section class="operation-preview-section">
        <h3>{{ 'package_operation.form.component_preview' | translate }}</h3>
        <div class="operation-preview-table-wrap">
          <table class="operation-preview-table">
            <thead>
              <tr>
                <th>{{ 'package_operation.form.component_sku' | translate }}</th>
                <th>{{ 'package_operation.form.qty_per_package' | translate }}</th>
                <th>{{ 'package_operation.form.current_available_qty' | translate }}</th>
                <th>{{ 'package_operation.form.available_after_operation' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of previewItems; track item.skuCode) {
                <tr [class.operation-preview-insufficient]="!item.stockEnough">
                  <td>{{ item.skuName }} - {{ item.skuCode }}</td>
                  <td>{{ item.qtyPerPackage | number }}</td>
                  <td>{{ item.currentAvailableQty | number }}</td>
                  <td>
                    @if (stockChecking) {
                      <i
                        class="pi pi-spinner pi-spin operation-preview-spinner"
                        [attr.aria-label]="'common.messages.loading' | translate"
                      ></i>
                    } @else {
                      {{ item.availableQtyAfterOperation | number }}
                    }
                  </td>
                </tr>
              } @empty {
                <tr>
                  <td class="operation-preview-empty" colspan="4">
                    {{
                      (stockChecking
                        ? 'common.messages.loading'
                        : 'package_operation.form.preview_hint') | translate
                    }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    </form>
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <app-button
        [testId]="'package-operation-cancel'"
        [label]="'common.actions.cancel' | translate"
        type="action"
        class="operation-cancel"
        [disabled]="submitting"
        (emitOnClick)="close()"
      ></app-button>
      <app-button
        [testId]="'package-operation-submit'"
        [label]="(operationType === 'UNPACK' ? 'package_operation.actions.confirm_unpack' : 'package_operation.actions.confirm_pack') | translate"
        [type]="operationType === 'UNPACK' ? 'danger' : 'info'"
        [loading]="submitting"
        [disabled]="
          operationForm.invalid ||
          stockChecking ||
          stockEnough !== true ||
          (operationType === 'UNPACK' && !operationForm.controls.sourcePackOperationId.value)
        "
        (emitOnClick)="submitOperation.emit()"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>
